(function () {
  'use strict';
  var root = document.documentElement;
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { var m = document.getElementById('bh-menu'); if (m) { m.hidden = false; root.style.overflow = 'hidden'; } return; }
    if (e.target.closest('[data-menu-close]')) { var m2 = document.getElementById('bh-menu'); if (m2) { m2.hidden = true; root.style.overflow = ''; } return; }
    if (e.target.closest('[data-help-toggle]')) { var h = document.getElementById('bh-help'); if (h) h.hidden = !h.hidden; return; }
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) { var main = document.querySelector('[data-main-image]'); if (main) main.src = thumb.dataset.thumb; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var m = document.getElementById('bh-menu'); if (m && !m.hidden) { m.hidden = true; root.style.overflow = ''; }
    var h = document.getElementById('bh-help'); if (h) h.hidden = true;
  });

  document.querySelectorAll('[data-bh-form]').forEach(function (form) {
    var vEl = form.querySelector('[data-variants]');
    var mEl = form.querySelector('[data-money]');
    var variants = vEl ? JSON.parse(vEl.textContent) : [];
    var optEl = form.querySelector('[data-product-option-names]');
    var productOptionNames = optEl ? JSON.parse(optEl.textContent) : [];
    var money = mEl ? JSON.parse(mEl.textContent) : '${{amount}}';
    var idField = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-price]');
    var submit = form.querySelector('[data-submit]');
    var kicker = form.querySelector('[data-kicker-finish]');
    var sid = form.getAttribute('data-summary-id');
    var summaryEl = sid ? document.querySelector('[data-summary-for="' + sid + '"]') : form.querySelector('[data-build-summary]');

    function fmt(cents) {
      var n = (cents / 100).toFixed(2), whole = n.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','), dec = n.split('.')[1];
      return money
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.') + ',' + dec)
        .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + dec);
    }

    // Match real Shopify variants by their option VALUES as well as option names.
    // Shopify may call an option "Pattern" while the theme labels it "Curve".
    // If we only match option names, the storefront can incorrectly mark stocked
    // variants as sold out and send the wrong variant ID to checkout.
    function normalise(value) {
      return String(value == null ? '' : value).trim().toLowerCase();
    }
    function variantValues(variant) {
      return Array.isArray(variant.options) ? variant.options :
        [variant.option1, variant.option2, variant.option3].filter(function (v) { return v != null; });
    }
    function sync() {
      var parts = [], selections = [];
      form.querySelectorAll('[data-group]').forEach(function (g) {
        var c = g.querySelector('input:checked');
        if (!c) return;
        var suf = g.dataset.suffix;
        parts.push(c.value + (suf ? ' ' + suf : ''));
        selections.push({ name: g.dataset.name || '', value: c.value, pos: -1 });
      });
      if (summaryEl) summaryEl.textContent = parts.join(' · ');
      if (!variants.length || !idField) return;

      var firstValues = variantValues(variants[0]);
      var used = {};
      selections.forEach(function (selection) {
        // First prefer an exact Shopify option-name match.
        for (var i = 0; i < productOptionNames.length; i++) {
          if (!used[i] && normalise(productOptionNames[i]) === normalise(selection.name)) {
            selection.pos = i;
            used[i] = true;
            return;
          }
        }
      });
      selections.forEach(function (selection) {
        if (selection.pos !== -1) return;
        // Fall back to matching the option's VALUE across the product's variants.
        // This also handles renamed labels such as "Curve" vs "Pattern".
        for (var i = 0; i < firstValues.length; i++) {
          if (used[i]) continue;
          if (variants.some(function (v) { return normalise(variantValues(v)[i]) === normalise(selection.value); })) {
            selection.pos = i;
            used[i] = true;
            return;
          }
        }
        // A genuine custom option (Hand, Blade colour, etc.) is still submitted
        // as a line-item property, and should not restrict Shopify variant matching.
      });

      var matching = variants.filter(function (variant) {
        var values = variantValues(variant);
        return selections.every(function (s) {
          return s.pos === -1 || normalise(values[s.pos]) === normalise(s.value);
        });
      });
      var match = matching.find(function (v) { return v.available; }) || matching[0];
      if (match) {
        idField.value = match.id;
        if (priceEl) priceEl.textContent = fmt(match.price);
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? 'ADD TO CART' : 'SOLD OUT';
        }
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', u);
        }
      } else if (submit) {
        submit.disabled = true;
        submit.textContent = 'UNAVAILABLE';
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-file-input]')) {
        var label = form.querySelector('[data-file-name]');
        if (label && e.target.files[0]) label.textContent = e.target.files[0].name;
      }
      sync();
    });
    sync();
  });

  window.addEventListener('message', function (e) {
    var d = e.data;
    if (!d || typeof d !== 'object') return;
    var ref = d.designId || d.design_id || d.configurationId;
    if (!ref) return;
    document.querySelectorAll('[data-design-ref]').forEach(function (f) { f.value = ref; });
  });
})();
